import { engagementCampaignsGlobalFrequencyCapsAppGroupId } from "../engagementCampaignsGlobalFrequencyCapsAppGroupId";
import type { AllRouteEndpoints } from "../routeTypes";

export const engagementCampaignsSetGlobalFrequencyCapsCacheKeys: AllRouteEndpoints[] = [
  engagementCampaignsGlobalFrequencyCapsAppGroupId,
];
